import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Forwarder, ForwarderCreate, ForwarderCreateResponse, ForwarderUpdate } from '../../../shared/interfaces/forwarder.interfaces';

const basePath = '/dealer/forwarder';

@Injectable({
  providedIn: 'root'
})

export class DealerForwarderService {
  constructor(private http: HttpClient) { }

  // Gets all forwarders for the current dealer
  getForwarders(): Observable<Forwarder[]> {
    return this.http.get<Forwarder[]>(`${basePath}`);
  }

  // Creates a new forwarder for the current dealer
  createForwarder(payload: ForwarderCreate): Observable<ForwarderCreateResponse> {
    let body: any;
    const requiresIpAndPort = ['NT', 'SG_CLIENT', 'DC09_TCP', 'DC09_UDP'].includes(payload.type);
    if (requiresIpAndPort && (payload.port !== null || payload.ip !== null)) {
      body = {
        "type": payload.type,
        "description": payload.description,
        "ip": payload.ip,
        "port": payload.port,
        "enabled": payload.enabled
      };
    } else if (payload.type === 'SG') {
      body = {
        "type": payload.type,
        "description": payload.description,
        "enabled": payload.enabled
      };
    } else {
      throw new Error('Invalid parameters for creating forwarder');
    }
    return this.http.post<ForwarderCreateResponse>(`${basePath}`, body);
  }

  // Gets details of a specific forwarder
  getForwarderById(id: number): Observable<Forwarder> {
    return this.http.get<Forwarder>(`${basePath}/${id}`);
  }

  // Deletes a specific forwarder
  deleteForwarder(id: number) {
    return this.http.delete(`${basePath}/${id}`);
  }

  // Updates a specific forwarder
  updateForwarder(payload: ForwarderUpdate): Observable<Forwarder> {
    let body: any;
    const requiresIpAndPort = ['NT', 'SG_CLIENT', 'DC09_TCP', 'DC09_UDP'].includes(payload.type);
    if (requiresIpAndPort && (payload.port !== null || payload.ip !== null)) {
      body = {
        "type": payload.type,
        "description": payload.description,
        "port": payload.port,
        "ip": payload.ip,
        "enabled": payload.enabled
      };
    } else if (payload.type === 'SG') {
      body = {
        "type": 'SG',
        "description": payload.description,
        "enabled": payload.enabled
      };
    } else {
      throw new Error('Invalid parameters for editing forwarder');
    }
    return this.http.put<Forwarder>(`${basePath}/${payload.id}`, body);
  }

}
